/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import { FaAngleLeft } from 'react-icons/fa'
import { WidowSize } from '../../utilities/windowSize'
import { ShortString } from '../../utilities/generator'

const Translate = {
  1: 'در حال بررسی',
  2: 'منعقد شده',
  3: 'کنسل شده',
}

const Link_Box2 = (props) => {
  return (
    <a
      href={props.link}
      className={`link-box-2  ${props.type == 2 ? 'type-2' : 'box-shadow'}`}
    >
      <span className='fileNumber'>پرونده شماره {props.number}</span>
      <div>
        <h4>{props.title}</h4>
        <div className='status'>
          <div className='nav'>
            <div className={`type-${props.status}`}>
              {Translate[props.status]}
            </div>
            {WidowSize.width < 576 ? (
              <div>{props.name}</div>
            ) : (
              <div>{ShortString(props.name)}</div>
            )}
          </div>
          <div className='icon'>
            <FaAngleLeft />
          </div>
        </div>
        <div className='data'>
          <span>شروع {props.start}</span>
          <span>/</span>
          <span>پایان {props.end}</span>
        </div>
      </div>
    </a>
  )
}
export default Link_Box2
